import React, { useContext } from 'react';
import { getImageWithResamplingQuery } from 'util/index';
import { createUseStyles } from 'react-jss';
import IsPlayingOverlay from 'components/IsPlayingOverlay';
import styles from './StationTile.styles';
import HoverOverlay from 'components/Tiles/StationTile/HoverOverlay';
import AudioIcon from 'components/svg/Audio';
import Marquee from 'components/Marquee';
import CollectionContext from 'components/Collection/CollectionContext';
import { isMobile, isTouch } from 'util/device';
import { IStationTile } from './StationTile.interface';
import classNames from 'classnames';

const useStyles = createUseStyles(styles, { name: 'StationTile' });

const StationTile = (props: IStationTile): JSX.Element => {
  const { station, browser, onPlayToggle, saveRecentSearch } = props;

  const { showNowPlayingInfo = true } = useContext(CollectionContext);
  const classes = useStyles();
  const PLAY_BUTTON_SIZE = browser.down.sm ? 45 : 55;

  const isPlayingOverlayProp = {
    isPlayingWrapperClass: classes.isPlayingWrapper,
    isActive: props.isActive,
    isPlaying: props.isPlaying,
    size: PLAY_BUTTON_SIZE,
  };

  const hoverOverlayProps = {
    onPlayToggle: onPlayToggle,
    isPlaying: props.isPlaying,
    isLoading: props.isLoading,
    station: {
      contentTypeId: station.contentTypeId,
      slug: station.slug,
      title: station.title,
      linkedPage: station.linkedPage,
      name: station.name,
      id: station.id,
      hasPage: station.hasPage,
      collectionTitle: station.collectionTitle,
    },
    playButtonSize: PLAY_BUTTON_SIZE,
  };

  const marqueeProps = {
    text: station.playouts,
    icon: <AudioIcon />,
  };

  const clickHandler = () => {
    if (isTouch) {
      onPlayToggle();
      saveRecentSearch(station.contentTypeId, station.slug);
    }
  };

  return (
    <div className={classes.wrapper}>
      <div
        data-key="tile-image"
        data-testid={`station-tile-${station.slug}`}
        style={{
          backgroundColor: station.brandColor,
          backgroundImage: `url(${getImageWithResamplingQuery({ url: station.image?.url })})`,
        }}
        className={classNames(classes.tile, {
          [classes.nonTouchTile]: !isTouch,
        })}
        onClick={isTouch ? clickHandler : undefined}
      >
        <div className={classes.content}>
          {station.audioUrl && (
            <h2
              className={classNames(classes.title, {
                [classes.touch]: isTouch,
              })}
            >
              {station.shortTitle || station.title || 'Radio'}
            </h2>
          )}
        </div>
        {(isTouch || !isMobile) && <IsPlayingOverlay {...isPlayingOverlayProp} />}
        {!isTouch && !isMobile && <HoverOverlay {...hoverOverlayProps} />}
      </div>
      {!isTouch && showNowPlayingInfo && <Marquee {...marqueeProps} />}
    </div>
  );
};

export default StationTile;
